module.exports = __webpack_public_path__ + "static/media/ngo.b2b1a94c.jpeg";